import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import dates from '@/utils/dates';

const objectType = 'sites';

class SitesService extends BaseService {

  static getList(page) {

    let url = `sites?page[number]=${page}&page[size]=${this.pageSize()}`;
    if (page === 'all') {
      url = `sites?paginate=false`;
    }

    return super.get(url)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static siteSearch(search) {
    return this.search(search);
  }

  static search(search, page) {

    return super.get(`sites/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }


  static getDetails(id) {
    return super.get(`sites/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities['sites'][object.result['sites'][0]];
        data.comments = object.entities.comments;
        data.trapSites = object.entities['trap-sites'];
        data.larvalSites = object.entities['larval-sites'];
        data = camelizeKeys(data);
        data = dates.datepickerFormat(data, ['foundDate', 'contactDate', 'scheduleStart']);
        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {

    data = dates.apiFormat(data, ['foundDate', 'contactDate', 'scheduleStart']);

    return super.post(objectType, `sites`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {
    data = dates.apiFormat(data, ['foundDate', 'contactDate', 'scheduleStart']);
    return super.patch(objectType, `sites/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`sites/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default SitesService;
